import { Button, Typography } from '@mui/material';
import { ISubCategory } from 'API/UniversalRequest/universalRequest';
import { getDisabilityConfirmationPdf } from 'API/disabilityConfirmation';
import { Loader } from 'Components';
import { useIsOtpLogin } from 'Hooks';
import { downloadFile } from 'Utils';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ISubCategoriesListItem {
  subCategory: ISubCategory;
  handleSubCategoryClick: (id: number) => void;
}

export const SubCategoriesListItem = ({
  subCategory,
  handleSubCategoryClick,
}: ISubCategoriesListItem) => {
  const { isOtp } = useIsOtpLogin();
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const onclick = async () => {
    if (subCategory.attachmentId) {
      setIsLoading(true);
      const sourceBase64 = await getDisabilityConfirmationPdf(
        subCategory.attachmentId
      );

      if (sourceBase64?.file)
        downloadFile(
          sourceBase64.file,
          '.pdf',
          subCategory.disabilityName || ''
        );

      setIsLoading(false);
    } else if (!isOtp && subCategory.link) {
      navigate(subCategory.link);
    } else handleSubCategoryClick(subCategory.id);
  };

  return (
    <Button
      variant='secondary2'
      role={subCategory.link ? 'link' : 'button'}
      sx={{
        p: '15px 16px',
        color: 'inherit',
        justifyContent: 'start',
        ':focus': { bgcolor: '#081E54', color: 'white', border: 'none' },
      }}
      onClick={onclick}
      onKeyDown={onEnterOrEscapeKeyDown}
      disableFocusRipple
    >
      {isLoading ? (
        <Loader sx={{ height: '100%', overflow: 'hidden' }} size={24} />
      ) : (
        <Typography fontSize='20px' fontWeight='600' lineHeight='24px'>
          {subCategory.title}
        </Typography>
      )}
    </Button>
  );
};
